import { Button, FormGroup, Text, TextArea } from '@ksyos/design-system';
import { useState } from 'react';
import { processActivityCancelSchema } from '@common/validation/processActivityCancel';
import { Modal } from '@frontend/components/elements/modals/Modal';
import { getSelectedLanguage } from '@frontend/translate';
import { getValidationErrorTranslation } from '@frontend/utils';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { emptyValidationErrors, validate } from '@frontend/utils/validation';
import { PatientEpisodeCategoryCarePathContext } from '../../../patientEpisodeCategoryCarePathContext';
import { ProcessActivityReadContext } from './processActivityReadContext';

type ProcessActivityCancelModalProps = Readonly<{
    onClose: () => void;
}>;

export function ProcessActivityCancelModal(props: ProcessActivityCancelModalProps): JSX.Element {
    const { onClose } = props;
    const { processActivity } = useDefinedContext(ProcessActivityReadContext);
    const { cancelProcessActivityAndReload } = useDefinedContext(PatientEpisodeCategoryCarePathContext);
    const [reason, setReason] = useState('');
    const [errors, setErrors] = useState(emptyValidationErrors);
    const activityName = processActivity.serviceActivity.name;

    return (
        <Modal
            actionButtons={[
                <Button
                    color="neutral"
                    key={'no'}
                    onClick={onClose}
                    variant="outline"
                >
                    {getSelectedLanguage().common.no}
                </Button>,
                <Button
                    color="danger"
                    key={'yes'}
                    onClick={onConfirm}
                >
                    Ja, annuleer {activityName}
                </Button>,
            ]}
            isOpen={true}
            onClose={onClose}
            size="medium"
            title={`${activityName} annuleren`}
        >
            <Text>Weet je zeker dat je de {activityName} wilt annuleren?</Text>
            <br />
            <FormGroup
                hasErrors={errors.has('reason')}
                isRequired={true}
                label="Reden van annuleren"
                layout="vertical"
            >
                <TextArea
                    error={getValidationErrorTranslation(errors.get('reason'))}
                    onChange={(e) => {
                        setReason(e.target.value);
                        validateReason(e.target.value);
                    }}
                    value={reason}
                />
            </FormGroup>
        </Modal>
    );

    async function onConfirm() {
        const confirmErrors = validateReason(reason);
        if (confirmErrors.size > 0) {
            return;
        }
        await cancelProcessActivityAndReload(processActivity.id, { reason });
        onClose();
    }

    function validateReason(value: string) {
        const { errors: validatedErrors } = validate(processActivityCancelSchema, { reason: value });
        setErrors(validatedErrors);

        return validatedErrors;
    }
}
